export const formatWeekRange = (rowData: any) => {
    const formatDate = (dateString: string) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { dateStyle: "medium" });
    };

    const start = formatDate(rowData?.startDate);
    const end = formatDate(rowData?.endDate);
    return `${start} to ${end}`;
};